import { GlobalWorkerOptions } from 'pdfjs-dist';

// Use the self-hosted worker (ESM)
GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

export default GlobalWorkerOptions;